import debug from "debug";
const MODULE_NAME = 'core/modules/sliders';
const ELEMENT_SELECTOR = '.block-slider';
import blocks from './blocks';

const log = debug(MODULE_NAME);
export default function exec () {
	if ($(ELEMENT_SELECTOR).length) {
		blocks();
	}
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/carousel-block/index.js